module.exports = __webpack_public_path__ + "img/nose_male_average.d26b15fc.png";